import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {glassTubeItemDrop, glassTubeRemoveItem, setPlantsInScene, setStoppersInScene, setBoxesInScene} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    type: state.notebook.protocolSection.scene.apparatus.glassTubes[ownProps.id-1].type,
    plantId: state.notebook.protocolSection.scene.apparatus.glassTubes[ownProps.id-1].plantId,
    boxId: state.notebook.protocolSection.scene.apparatus.glassTubes[ownProps.id-1].boxId,
    stopperId: state.notebook.protocolSection.scene.apparatus.glassTubes[ownProps.id-1].stopperId,
    solution: state.notebook.protocolSection.scene.apparatus.glassTubes[ownProps.id-1].solution,
    solutions: state.notebook.protocolSection.scene.apparatus.glassTubes[ownProps.id-1].solutions,
    volume: state.notebook.protocolSection.scene.apparatus.glassTubes[ownProps.id-1].volume,
    tubeLabel: state.notebook.protocolSection.scene.apparatus.glassTubes[ownProps.id-1].tubeLabel,

  }
}

function mapDispatchToProps(dispatch) {
  return {
    onDropItem: (data)=>{
      dispatch(glassTubeItemDrop(data))
    },
    setPlantsInScene: (data) => {
      dispatch(setPlantsInScene(data))
    },
    setStopperInScene: (data) => {
      dispatch(setStoppersInScene(data))
    },
    setBoxInScene: (data) => {
      dispatch(setBoxesInScene(data))
    },
    onRemoveItem: (data)=>{
      dispatch(glassTubeRemoveItem(data))
    }
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
